import React, {useState} from 'react';

import styles from './SearchByVin.module.css';
import {Input} from "../../ui/DataEntry/Input/Input.tsx";
import {Button} from "../../ui/General/Button/Button.tsx";
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";

interface Props {

}

export const SearchByVin: React.FC<Props> = () => {
    const {isMobile, isDesktop} = useScreenDetector();
    const [vin, setVin] = useState<string>('');
    const [partName, setPartName] = useState<string>('');

    return (
        <div className={styles.container}>
            {isMobile && (<>
                <h2 className={styles.title}>Поиск по VIN или номеру кузова</h2>
                <div className={styles.inputs}>
                    <Input className={styles.input} value={vin} placeholder='VIN или номер кузова' changeStateValue={setVin}/>
                </div>
                <div className={styles.inputs}>
                    <Input
                        className={styles.input}
                        placeholder='Наименование запчасти'
                        value={partName}
                        changeStateValue={setPartName}
                    />
                    <Button type='search' id='search-car-by-vin-btn' onClick={() => document.location = partName ? `/search-vehicle-with-name?vin=${vin}&partName=${partName}` : `/search-vehicle?vin=${vin}`}/>
                </div>
                <p className={styles.hint}>Введите VIN или номер кузова, например&nbsp;
                    <span className={styles.textDecorated}>JTJHK31U802038156</span>
                </p>
            </>)}

            {isDesktop && (<>
                <p className={styles.hint}>Введите VIN или номер кузова, например&nbsp;
                    <span className={styles.textDecorated}>JTJHK31U802038156</span>
                </p>
                <div className={styles.inputs}>
                    <Input className={styles.input} value={vin} placeholder='VIN или номер кузова' changeStateValue={setVin}/>
                    <Input
                        className={styles.input}
                        placeholder='Наименование запчасти'
                        value={partName}
                        changeStateValue={setPartName}
                    />
                    <Button type='search' id='search-car-by-vin-btn' onClick={() => document.location = partName ? `/search-vehicle-with-name?vin=${vin}&partName=${partName}` : `/search-vehicle?vin=${vin}`}/>
                </div>
            </>)}
        </div>
    )
}